module.exports = __webpack_public_path__ + "static/img/20250401001.25c7f22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20250401001.jpg
// module id = brUf
// module chunks = 0